import {FormGroup} from '@angular/forms';
import {IDomainResponse} from '../../interfaces/IDomainResponse';
import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {DomainService} from '../../services/domain/domain.service';

@Component({
  selector: 'app-domain-input-select',
  templateUrl: './domain-input-select.component.html',
  styleUrls: ['./domain-input-select.component.scss'],
})
export class DomainInputSelectComponent implements OnInit {
  @Input() formControlName: string;
  @Input() formParent: FormGroup;

  @Input() label: string;
  @Input() description: string;
  @Input() errorMessage: string;
  @Output() isLoading = true;
  @Output() formParentChange = new EventEmitter<FormGroup>();
  domainResponse: IDomainResponse[] = [];

  constructor(private domainService: DomainService) {
  }

  ngOnInit(): void {
    const initialValue = this.formParent.get(this.formControlName)?.value;
    this.domainService.getDomainResponseList().subscribe({
      next: (response) => {
        this.domainResponse = response.data;
        this.formParent.get(this.formControlName)?.setValue(initialValue);
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.log(err);
      },
    });
  }

  changeDomain() {
    this.formParentChange.emit(this.formParent);
  }
}
